// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host .call-status {
  height: 26px;
  color: white;
}
:host .call-status .call-status-icon {
  width: 12px;
  height: 12px;
}
:host .call-status .status-active,
:host .call-status .status-unavailable,
:host .call-status .status-break {
  padding-left: 15px;
  position: relative;
  font-size: 12px;
  padding-top: 2px;
  text-transform: uppercase;
  font-family: Roboto-Medium;
}
:host .call-status .status-active:before,
:host .call-status .status-unavailable:before,
:host .call-status .status-break:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #2ee02e;
  border-radius: 50%;
  display: inline-block;
  margin-right: 12px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
:host .call-status .status-active:before {
  background: #2ee02e;
  border: 2px solid #1fa266;
}
:host .call-status .status-unavailable:before {
  background: #f94e4e;
  border: 2px solid #b62323;
}
:host .call-status .status-break:before {
  background: #ffc54b;
  border: 2px solid #dab668;
}
:host ul {
  list-style: none;
  position: absolute;
  display: none;
  background: var(--cs-secondary-color);
  filter: brightness(1.2);
  top: 100%;
  left: 0;
  padding: 0;
  text-align: left;
  min-width: 150px;
  font-family: Roboto-Light;
}
:host ul li {
  padding: 0.8rem 1.5rem;
  line-height: 1rem;
  white-space: nowrap;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
:host:hover ul {
  display: block;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
